export const DonatikTipsTranslation = {
    en: `
Donatik API Setup

![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/payment-methods/donatik/1.webp "Overlay Url")

![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/payment-methods/donatik/2.webp "Overlay Url")

The nickname can be found in the Pseudonym field on the Profile tab in Settings. It is used to redirect viewers to the Donatik page.

![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/payment-methods/donatik/3.webp "Overlay Url")
    `,
    uk: `
Налаштування API Donatik

![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/payment-methods/donatik/1.webp "Overlay Url")

![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/payment-methods/donatik/2.webp "Overlay Url")

Нікнейм можна знайти на вкладці «Профіль» в налаштуваннях, у полі «Псевдонім». Воно буде використовуватися для перенаправлення на сторінку Donatik.

![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/payment-methods/donatik/3.webp "Overlay Url")
    `
}
